import { Row } from 'src/shared/components/Semantic/all'
import { Badge } from 'src/shared/components/ui/badge'
import { useLocalization } from 'src/shared/hooks/useLocalization'

type Category = {
  id: number
  category?: {
    title?: string
  }
}

export const ProductCategories = ({
  categories,
  articleNumber,
  variant = 'mobile',
}: {
  categories?: Category[]
  articleNumber?: string
  variant?: 'mobile' | 'desktop'
}) => {
  const { t } = useLocalization()

  if (variant === 'mobile') {
    return (
      <Row className="gap-1 items-center">
        {categories?.map((category) => (
          <Badge key={category.id}>
            {t(
              category?.category?.title?.split(',')[0] ?? '',
              category?.category?.title?.split(',')[1] ?? ''
            )}
          </Badge>
        )) || null}
        <p className="text-xs ml-1">SKU: {articleNumber}</p>
      </Row>
    )
  }

  return (
    <Row className="gap-2 items-center flex-wrap">
      {categories?.map((category) => (
        <Badge key={category.id}>
          {t(
            category?.category?.title?.split(',')[0] ?? '',
            category?.category?.title?.split(',')[1] ?? ''
          )}
        </Badge>
      ))}
      <p className="text-xs text-foreground/60 ml-auto">SKU: {articleNumber}</p>
    </Row>
  )
}

